import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  or: () => i18n.t(i18nKeys.common__or),
  reschedule: () => i18n.t(i18nKeys.scheduleOrientationDetails__reschedule),
  h1: () => i18n.t(i18nKeys.scheduleOrientationDetails__h1),
  bgTitle: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgTitle),
  bgStepOne: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepOne),
  bgStepTwo: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepTwo),
  ausBgStepOne: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepOne),
  bgStepThree: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepThree),
  bgStepFour: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepFour),
  bgStepFive: () => i18n.t(i18nKeys.scheduleOrientationDetails__bgStepFive),
  whatToBring: () => i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring),
  whatToBringOne: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringOne),
  whatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringTwo),
  whatToBringThree: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringThree),
  whatToBringTwoAlt: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBringTwoAlt),
  ausWhatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__ausWhatToBringTwo),
  ausIdLink: () => i18n.t(i18nKeys.scheduleOrientationDetails__ausIdLink),
  prWhatToBringTwo: () =>
    i18n.t(i18nKeys.scheduleOrientationDetails__prWhatToBringTwo),
  jpBicycle: () => (
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring).concat(": ")
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__bicycle))),
  jpScooter: () => (
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring).concat(": ")
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__scooter125cc))),
  jpMotorcycle: () => (
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring).concat(": ")
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__scooter125ccMotor250cc))),
  jpCar: () => (
    i18n.t(i18nKeys.scheduleOrientationDetails__whatToBring).concat(": ")
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__car250ccMotor125cc))),
  jpBicycleReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__bicycleRequirements),
  jpBicycleForeignReq: () => (
    i18n.t(i18nKeys.scheduleOrientationConfirmation__foreignNational)
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__bicycleForeignRequirements))),
  jpOtherReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__otherRequirements),
  jpOtherForeignReq: () => (
    i18n.t(i18nKeys.scheduleOrientationConfirmation__foreignNational)
    .concat(i18n.t(i18nKeys.scheduleOrientationConfirmation__otherForeignRequirements))),
  jpOtherInsuranceReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__otherInsuranceRequirements),
  jpOtherVoluntaryReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__otherVoluntaryInsuranceRequirements),
  jpOtherPhotoReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__otherPhotoRequirements),
  jpOtherSafetyCertReq: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__otherSafetyCertRequirements),
  jpVerifyIdentity: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__verifyIdentity),
  jpSubmitDocument: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__submitDocumentation),
  jpDownloadApp: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__downloadApp),
  jpVerifyIdentityWarn: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__verifyIdentityWarning),
  jpVerifyIdentityWarnText: () => i18n.t(i18nKeys.scheduleOrientationConfirmation__verifyIdentityWarningText),
  nextStep: () => i18n.t(i18nKeys.common__nextStep),
}
